import React, { useContext, useState, useEffect } from 'react';
import { SessionContext } from '../contexts/SessionContext';
import { APIContext } from '../contexts/APIContext';
import { PAGE_VIEW } from '../types';
import { Avatar, AvatarFallback, AvatarImage } from './ui/Avatar';
import { Toggle } from './ui/Toggle';
import { ChatbotContext } from '../contexts/ChatbotContext';
import { Tooltip, TooltipProvider, TooltipTrigger } from './ui/Tooltip';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { TooltipContent } from '@radix-ui/react-tooltip';
import { trackUserClicks, getValidToken } from '../utils';
import { useMsal } from '@azure/msal-react';
import ChatDownload from './ChatDownload';
import { useToast } from './ui/toast/UseToast';
import { ToastAction } from './ui/toast/Toast';

export const LeftNavbar = (props: any) => {
  const { toggleSideBarHandler } = props;
  const { pageView, setPageView, isPromptGenerating } = useContext(SessionContext);
  const {
    chatSessionId,
    userDetails,
    websocketConnectionRef: { current: websocket },
    exportedChatPPTURL,
    setExportedChatPPTURL,
    exportedChatDOCXURL,
    setExportedChatDOCXURL,
    WBUId,
    AppName,
    accounts,
    aRCGrowthAdminUser,
  } = useContext(APIContext);
  const { chatHistory, chatPromptResponseHistory } = useContext(ChatbotContext);
  // const { accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;
  const username = isAuthenticated ? accounts[0].username : ' ';
  const [chatDownload, setChatDownload] = useState<boolean>(false);
  const { toast } = useToast();

  const navBtns = [
    {
      name: 'Hub',
      icon: '/icons/hubNew1.svg',
      view: PAGE_VIEW.HUB,
      tooltipLabel: 'Generative AI',
      label: 'Generative AI',
    },
    {
      name: 'Chat',
      icon: '/icons/ChatNew.svg',
      view: PAGE_VIEW.CHAT,
      tooltipLabel: 'Chat',
      label: 'Chat',
    },
    {
      name: 'Chat History',
      icon: '/icons/Chat history.svg',
      view: PAGE_VIEW.HISTORY,
      tooltipLabel: 'Chat History',
      label: 'Chat History',
    },
    {
      name: 'Upload',
      icon: '/icons/upload.svg',
      view: PAGE_VIEW.UPLOAD,
      tooltipLabel: 'Export Chat',
      label: 'Export Chat',
    },
    // {
    //   name: 'Settings',
    //   icon: '/icons/settings-new.svg',
    //   view: PAGE_VIEW.SETTINGS,
    //   tooltipLabel: 'Coming Soon',
    // },
    {
      name: 'Help',
      icon: '/icons/help-new.svg',
      view: PAGE_VIEW.HELP,
      tooltipLabel: 'Frequently asked questions',
      label: 'FAQs',
    },
    {
      name: 'Upload Transcript',
      icon: '/icons/Transcript.svg',
      view: PAGE_VIEW.TRANSCRIPT,
      tooltipLabel: 'Upload Transcript',
      label: 'Upload Transcript',
    },
  ];

  const iconBtnsToDisableInMobile = new Set(['Chat History', 'Upload', 'Hub', 'Help']);
  const iconBtnsToHideInDesktop = new Set(['Chat History']);
  const screenWidth = screen.width;

  const handleNavbarClick = async (view: PAGE_VIEW) => {
    const token = await getValidToken();
    if (view === pageView) {
      trackUserClicks(websocket, 'GMA Landing Page', userDetails, chatSessionId, WBUId, AppName, accounts, token);
      setPageView(PAGE_VIEW.LANDING);
    } else if (view === 'upload') {
      //Show Chatdownload popup only if prompt history available
      if (chatPromptResponseHistory && chatPromptResponseHistory.length > 0) {
        setChatDownload(true); //Set to true to display chat download popup.
        // setPageView(PAGE_VIEW.UPLOAD);
      } else {
        //Show toaster when there is no prompt history to download
        toast({
          description: 'No chat transcript available to be exported',
        });
        // toast({
        //   status: 'success',
        //   // title: 'title',
        //   description: 'Removed from Storybuilder',
        //   action: (
        //     <ToastAction
        //       altText="View Storybuilder"
        //       className="flex items-center justify-center w-[max-content] h-full font-graphik text-[12px] text-gamma-purple"
        //     >
        //       View Storybuilder
        //     </ToastAction>
        //   ),
        // });
      }
    } else if (view === PAGE_VIEW.HUB) {
      window.open('https://reinventionconsole.accenture.com/arc-genai/genarc/landing', '_blank');
      trackUserClicks(websocket, 'Generative AI', userDetails, chatSessionId, WBUId, AppName, accounts, token);
    } else if (view === PAGE_VIEW.CHAT) {
      trackUserClicks(websocket, 'GMA Chat LandingPage', userDetails, chatSessionId, WBUId, AppName, accounts, token);
      setPageView(PAGE_VIEW.CHAT);
    } else if (view === PAGE_VIEW.TRANSCRIPT) {
      trackUserClicks(websocket, 'UploadTranscript', userDetails, chatSessionId, WBUId, AppName, accounts, token);
      setPageView(PAGE_VIEW.TRANSCRIPT);
    } else if (view === 'help') {
      setPageView(PAGE_VIEW.HELP);
      // trackUserClicks(websocket, '', userDetails, chatSessionId);
    } else {
      trackUserClicks(websocket, 'GMA Landing Page', userDetails, chatSessionId, WBUId, AppName, accounts, token);
      setPageView(view);
    }
    toggleSideBarHandler(false);
  };

  // useEffect to watch for the exportedStoryPPTURL to be set
  useEffect(() => {
    if (exportedChatPPTURL) {
      // Open the URL in a new tab
      if (window.self === window.top) {
        window.open(exportedChatPPTURL, '_self');
      } else {
        //when app embedded in iframe use _blank as target
        window.open(exportedChatPPTURL, '_blank');
      }
      // Display the success toast message
      toast({
        status: 'success',
        description: 'Your PowerPoint has been generated!',
        action: (
          <ToastAction
            altText="View Storybuilder"
            onClick={() => window.open(exportedChatPPTURL, '_blank')}
            className="flex items-center justify-center w-[max-content] h-full font-graphik text-[16px] font-semibold tracking-[-0.32px] text-gamma-purple"
          >
            Download hasn&apos;t started? Click here
          </ToastAction>
        ),
      });
      // Reset the exportedStoryURL and exportStoryInProgress
      setExportedChatPPTURL('');
    }
  }, [exportedChatPPTURL]);

  // useEffect to watch for the exportedStoryDOCXURL to be set
  useEffect(() => {
    if (exportedChatDOCXURL) {
      // Open the URL in a new tab
      if (window.self === window.top) {
        window.open(exportedChatDOCXURL, '_self');
      } else {
        window.open(exportedChatDOCXURL, '_blank');
      }
      // Display the success toast message
      toast({
        status: 'success',
        description: 'Your DOCX has been generated!',
        action: (
          <ToastAction
            altText="View Storybuilder"
            onClick={() => window.open(exportedChatDOCXURL, '_blank')}
            className="flex items-center justify-center w-[max-content] h-full font-graphik text-[16px] font-semibold tracking-[-0.32px] text-gamma-purple"
          >
            Download hasn&apos;t started? Click here
          </ToastAction>
        ),
      });
      // Reset the exportedStoryURL and exportStoryInProgress
      setExportedChatDOCXURL('');
    }
  }, [exportedChatDOCXURL]);
  return (
    <div
      className={`navbar fixed z-[11] flex h-screen flex-col bg-[#000000] w-[80%] tablet:w-[64px] tablet:min-w-[64px] ${
        WBUId !== '' && window.self !== window.top ? 'top-0' : 'top-[54px]'
      }`}
    >
      {/* <div className="user-container flex h-[80px] items-center justify-center py-4 px-3">
        <Avatar className="w-12 h-12 hover:cursor-pointer" onClick={() => handleNavbarClick(PAGE_VIEW.LANDING)}>
          <AvatarImage src="/navbar-avatar-img.svg" />
          <AvatarFallback>
            <span className="material-symbols-outlined text-[48px] text-white">account_circle</span>
          </AvatarFallback>
        </Avatar>
      </div> */}
      <div className="navbar-toggle-container navbar-inner-wrapper flex h-full flex-col items-center justify-start px-4 tablet:px-0 font-graphik">
        <div className="text-white w-full flex flex-row justify-between py-3 tablet:hidden">
          <div>Menu</div>
          <div onClick={() => toggleSideBarHandler(false)}>X</div>
        </div>
        <div className="navbar-btns-container w-full flex flex-col">
          <TooltipProvider>
            {navBtns.map((navBtn, index) => (
              <Tooltip key={index}>
                <TooltipTrigger>
                  {/* Info icon */}
                  <Toggle
                    aria-label={navBtn.name}
                    key={index}
                    pressed={pageView === navBtn.view}
                    className={`custom-cursor-button h-[4rem] w-full ${
                      isPromptGenerating || (pageView === PAGE_VIEW.HELP && navBtn.view === PAGE_VIEW.UPLOAD)
                        ? 'not-clickable'
                        : ''
                    } ${
                      navBtn.view === PAGE_VIEW.HUB
                        ? WBUId !== '' && window.self !== window.top
                          ? 'hidden'
                          : 'block'
                        : ''
                    }
                    ${
                      !aRCGrowthAdminUser && navBtn.view === PAGE_VIEW.TRANSCRIPT
                        ? 'opacity-50 not-clickable cursor-default'
                        : ''
                    }
                    ${
                      screenWidth <= 768 && iconBtnsToDisableInMobile.has(navBtn.name)
                        ? 'opacity-50 not-clickable cursor-pointer'
                        : ''
                    }
                    ${screenWidth > 768 && iconBtnsToHideInDesktop.has(navBtn.name) ? 'hidden' : 'block'}
                    `} //prevent naviagtion when prompt is generating
                    onPressedChange={() =>
                      (navBtn.view === PAGE_VIEW.CHAT ||
                        navBtn.view === PAGE_VIEW.UPLOAD ||
                        navBtn.view === PAGE_VIEW.HUB ||
                        navBtn.view === PAGE_VIEW.HELP ||
                        navBtn.view === PAGE_VIEW.TRANSCRIPT) &&
                      handleNavbarClick(navBtn.view)
                    }
                  >
                    <div className="w-full flex flex-row justify-start tablet:justify-center items-center text-sm">
                      <img
                        className={`navbar-btn-icon ${
                          pageView === PAGE_VIEW.HELP && navBtn.view === PAGE_VIEW.UPLOAD
                            ? 'opacity-50 pointer-none'
                            : 'cursor-pointer'
                        }`}
                        src={navBtn.icon}
                        alt={navBtn.name + ' icon'}
                      />
                      <p className="navbar-btn-label px-3 tablet:hidden">{navBtn.label}</p>
                    </div>
                  </Toggle>
                </TooltipTrigger>
                <TooltipContent
                  side="right"
                  className="bg-[#505050] border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2"
                  sideOffset={5}
                >
                  <p className="tooltip-content text-white text-xs not-italic">{navBtn.tooltipLabel}</p>
                  <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#505050' }} />
                </TooltipContent>
              </Tooltip>
            ))}
          </TooltipProvider>
        </div>
      </div>
      {chatDownload && <ChatDownload chatDownload={chatDownload} setChatDownload={setChatDownload} />}
    </div>
  );
};
